module.exports = {"home":{"title":"NPI System","startDate":"วันที่เริ่มต้น","endDate":"วันที่สิ้นสุด","user":"ผู้ใช้งาน","action":"สถานะ","count":"จำนวน","topActionByUser":"ผู้ใช้งานที่ใช้งานสูงสุด ในแต่ละสถานะ","version":"เวอร์ชัน","Hi":"สวัสดี","Welcome to systems management":"ยินดีต้อนรับสู่การจัดการระบบ","Manage your Tracker":"การจัดการการติดตามงาน","Manage your Car reserve":"การจัดการระบบจองรถ","Manage your Project":"การจัดการโปรเจ็ค","Manage your systems":"การจัดการระบบ"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/home.json
// module id = 745
// module chunks = 116